import React, { cloneElement, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './BuyContainer.scss';

import { moduleActions } from '../../redux/modules';
import { getBucketRoll } from '../../redux/modules/bucketRoll/bucketRoll.selectors';
import {
  getEligibleBanks,
  getIsSingleBankWithDisabledStatus,
} from '../../redux/modules/existingBanks/existingBanks.selectors';
import {
  getIsFullyContributedIRA,
  getWindowCutoffDate,
} from '../../redux/modules/funds/IRA/IRA.selectors';
import {
  getDateOfBirth,
  getIsAddressAvailable,
  getIsNotForeignAddress,
  didPersonalInformationFail,
  getHouseholdBalanceTierStatus,
} from '../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import {
  getAvailableFundList,
  getAvailableFundListRecurring,
  getIsCorporateAccountType,
  getCurrentYearInclusiveRemainingContributions,
  getFlattenedPurchasingFunds,
  getFlattenedPurchasingFundsRecurring,
  getIRADataLookUp,
  getHasAtleastOneFullyContributedIRA,
  getHasAtleastOneFullyContributedIRARecurring,
  getNonRetirementMaxLimit,
  getPriorYearInclusiveRemainingContributions,
  getPurchasingFunds,
  getPurchasingFundsIncludesNew,
  getRecurringPurchasingFunds,
  getSelectedFunds,
  getSelectedFundsRecurring,
  getShoppingCartTotal,
  getUserFundList,
  hasStopTransferFunds,
  getAvailableEditFund,
  getFlattenedEditFundRecurring,
  hasRasFundsOnly,
  hasAppFundsOnly,
  userFundsSelectvsInfoCallsIRAAutoMax,
} from '../../redux/modules/shoppingCart/shoppingCart.selectors';
import { getSelectedBank } from '../../redux/modules/bankSelection/bankSelection.selectors';
import {
  getHasRetirementFunds,
  getUserOwnedIRAs,
} from '../../redux/modules/funds/UserFunds/userFunds.selectors';
import {
  analyticsDataLayer,
  dispatchPageLoad,
} from '../../redux/utils/analytics-helper';

import {
  isAppBuy,
  isBuy,
  isRecurringBuyEdit,
} from '../../utils/transactions-util';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../redux/modules/authentication/authentication.module.selectors';
import { snakeCase, toUpper, uniq } from 'lodash';
import { getIRAAutoMaxCalculationResponse } from '../../redux/modules/funds/IRAAutoMaxCalculation/IRAAutoMaxCalculations.selectors';
import { getActualCurrentYearRemainingContributions } from '../../redux/modules/funds/IRAAutoMaxCartDetails/IRAAutoMaxCartDetails.selectors';
import { getApplicationStatus } from '../../redux/modules/applicationData/applicationData.selectors';

require('animate.css/animate.min.css');

export class BuyContainer extends Component {
  componentDidMount() {
    const {
      actions: { getTRPFunds, loadApplication, setAppLoading },
    } = this.props;
    getTRPFunds();
    setAppLoading();
    analyticsDataLayer();
    loadApplication(this.props.actions);
  }

  componentDidUpdate(prevProps) {
    const {
      personalInformation: { data: prevData },
    } = prevProps;
    const {
      personalInformation: { data },
      actions: { getContributionWindow },
      household,
      availableFunds,
    } = this.props;
    if (prevData !== data) {
      window.metricsData.user.clientTier = household?.householdAssetTier?.id;
      window.trpQualtrics.clientTier = household?.householdAssetTier?.id;
      getContributionWindow(data.primaryAddress.state);
    }
    try {
      analyticsDataLayer({
        accountTypes: uniq(
          availableFunds.map((fund) => toUpper(snakeCase(fund.productType)))
        ),
      });
    } catch (e) {
      // don't let analytics errors cause other things to fail
    }
  }

  render() {
    const { children, ...passthroughProps } = this.props;
    return (
      <div className="buy-container">
        {/* Nested View */}
        <div>
          {React.Children.map(children, (child) =>
            cloneElement(child, {
              ...passthroughProps,
              analyticsDataLayer,
              dispatchPageLoad,
            })
          )}
          <div className="buy-container-clear" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    authentication,
    automaticInvestments,
    bankSelection,
    editMode,
    editModeBank,
    executePurchase,
    iraAutoMaxSubmission,
    executeRecurringPurchase,
    existingBanks,
    eVerification,
    modals,
    progress,
    routing,
    shoppingCart,
    user,
    userFunds,
    userProductTypes,
    paperlessSetting,
    personalInformation,
    userRegistrationTypeInfo,
    IRALimit,
    allFunds,
    quickBuy,
    vanity: { vanityName },
  } = state;
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    authentication,
    applicationData: getApplicationStatus(state),
    availableFunds: isRecurringBuyEdit()
      ? getAvailableEditFund(state)
      : isBuy() || isAppBuy()
      ? getAvailableFundList(state)
      : getAvailableFundListRecurring(state),
    bankSelection,
    bucketRoll: getBucketRoll(state),
    currentYearInclusiveRemainingContributions:
      getCurrentYearInclusiveRemainingContributions(state),
    dateOfBirth: getDateOfBirth(state),
    editMode,
    editModeBank,
    eligibleBanks: getEligibleBanks(state),
    executePurchase: isRecurringBuyEdit()
      ? automaticInvestments
      : isBuy() || isAppBuy()
      ? executePurchase
      : executeRecurringPurchase,
    iraAutoMaxSubmission,
    existingBanks,
    eVerification,
    flattenedPurchasingFunds: isRecurringBuyEdit()
      ? getFlattenedEditFundRecurring(state)
      : isBuy() || isAppBuy()
      ? getFlattenedPurchasingFunds(state)
      : getFlattenedPurchasingFundsRecurring(state),
    hasAtleastOneFullyContributedIRA:
      isBuy() || isAppBuy()
        ? getHasAtleastOneFullyContributedIRA(state)
        : getHasAtleastOneFullyContributedIRARecurring(state),
    hasRetirementFunds: getHasRetirementFunds(state),
    household: getHouseholdBalanceTierStatus(state),
    IRADataLookUp: getIRADataLookUp(state),
    isAddressAvailable: getIsAddressAvailable(state),
    isNotForeignAddress: getIsNotForeignAddress(state),
    personalInfoFailed: didPersonalInformationFail(state),
    isCorporateAccountType: getIsCorporateAccountType(state),
    isFullyContributedIRA: getIsFullyContributedIRA(state),
    isSingleBankWithDisabledStatus: getIsSingleBankWithDisabledStatus(state),
    modals,
    nonRetirementMaxLimit: getNonRetirementMaxLimit(state),
    priorYearInclusiveRemainingContributions:
      getPriorYearInclusiveRemainingContributions(state),
    progress,
    purchasingFunds:
      isBuy() || isAppBuy()
        ? getPurchasingFunds(state)
        : getRecurringPurchasingFunds(state),
    routing,
    selectedBank: getSelectedBank(state),
    selectedFunds:
      isBuy() || isAppBuy()
        ? getSelectedFunds(state)
        : getSelectedFundsRecurring(state),
    shoppingCart,
    user,
    userFunds,
    userFundsList: getUserFundList(state),
    userProductTypes,
    paperlessSetting,
    personalInformation,
    purchasingFundsIncludesNew: getPurchasingFundsIncludesNew(state),
    shoppingCartTotal: getShoppingCartTotal(state),
    userRegistrationTypeInfo,
    vanityName,
    IRALimit,
    allFunds,
    quickBuy,
    stopTransfer: hasStopTransferFunds(state),
    windowCutoffDate: getWindowCutoffDate(state),
    hasRasFundsOnly: hasRasFundsOnly(state),
    hasAppFundsOnly: hasAppFundsOnly(state),
    doesUserHaveIRAs: getUserOwnedIRAs(state),
    hasIRAAutoMax: getActualCurrentYearRemainingContributions(state),
    responseIRAAutoMaxCalculate: getIRAAutoMaxCalculationResponse(state),
    iraAutoMaxHiddenFundsSelectCall:
      userFundsSelectvsInfoCallsIRAAutoMax(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  BuyContainer
);
